import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import S from 'app/features/landing/devices/components/Devices.styled';
import Heading from 'app/components/layout/Heading.styled';
import Text from 'app/components/layout/Text.styled';
import {
  titleKey,
  subtitleKey,
  imageUrl,
  imageUrl2X,
} from 'app/features/landing/devices/selectors';
import { isMultiTier } from 'app/features/products/selectors';
import DevicesProductCta from 'app/features/landing/devices/components/DevicesProductCta';
import DevicesViewPlansCta from 'app/features/landing/devices/components/DevicesViewPlansCta';

const UI = ({ titleKey, subtitleKey, imageUrl, imageUrl2X, isMultiTier }) => (
  <S.Devices>
    <S.Devices.Header>
      <Heading size="l" as={S.Devices.HeaderTitle}>
        <FormattedMessage id={titleKey} />
      </Heading>
      <Text size="xl" as={S.Devices.HeaderSubtitle}>
        <FormattedMessage id={subtitleKey} />
      </Text>
      {isMultiTier ? <DevicesViewPlansCta /> : <DevicesProductCta />}
    </S.Devices.Header>
    <S.Devices.ImageHolder>
      <S.Devices.Image
        src={imageUrl}
        srcSet={`${imageUrl2X} 2x`}
        alt="Devices"
      />
    </S.Devices.ImageHolder>
  </S.Devices>
);

UI.propTypes = {
  titleKey: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imageUrl2X: PropTypes.string.isRequired,
  isMultiTier: PropTypes.bool.isRequired,
};

const state = { titleKey, subtitleKey, imageUrl, imageUrl2X, isMultiTier };

const Devices = connect(state)(UI);

export { UI };

export default Devices;
